export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de lotes"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crear nuevo lote"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
          "same_producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mismo productor"])},
          "add_quality_inspect_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir"])},
          "add_package_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir empaque"])},
          "add_harvested_batch_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir cosecha"])},
          "add_harvested_exp_package_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir empaques obtenidos de cosecha"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to batch list"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create new batch"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
          "add_package_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add package"])}
        }
      }
    }
  })
}